function getOrdinal(n) {
    let suffix = 'th';
    if (n % 100 < 11 || n % 100 > 13) {
        switch (n % 10) {
        case 1: suffix = 'st'; break;
        case 2: suffix = 'nd'; break;
        case 3: suffix = 'rd'; break;
        }
    }
    return n + suffix;
}

document.addEventListener('DOMContentLoaded', () => {
    window.dataLayer = window.dataLayer || [];
    let allPromotions = [];
    const promotionByContainer = new WeakMap();
    const promotionByGridCell = new WeakMap();

    const isNavigableHref = (href = '') => {
        const value = (href || '').trim();
        return value !== '' && value !== '#' && value !== 'javascript:void(0)';
    };

    const hasClickableContent = (container) => {
        if (!container) return false;

        const clickableTargets = container.querySelectorAll('a[href], button, [onclick], [data-link-url], .multi-cta-button, .banner-button, .xy-button, .xy-section-container-link, .custom-banner-link, .multi-fallback-link, .dnd-link, .dnd-item');
        if (!clickableTargets.length) return false;

        return Array.from(clickableTargets).some((node) => {
            if (node.tagName === 'A') {
                return isNavigableHref(node.getAttribute('href')) || node.hasAttribute('onclick');
            }

            if (node.tagName === 'BUTTON') {
                return true;
            }

            if (node.hasAttribute('onclick')) {
                return true;
            }

            if (node.hasAttribute('data-link-url')) {
                return isNavigableHref(node.getAttribute('data-link-url'));
            }

            return false;
        });
    };

    // Push view_promotions event with all visible promos on the page
    (function() {
        const allContainers = Array.from(document.querySelectorAll('.dl-container'));
        const promotionName = document.getElementById('promo-name')?.dataset.promoName || window.location.pathname.split('/').pop();

        // Only include visible and clickable containers
        const visibleContainers = allContainers.filter(container => {
            const computedStyle = window.getComputedStyle(container);
            return computedStyle.display !== 'none' && hasClickableContent(container);
        });

        let promoIndex = 0;
        const promotions = [];
        
        visibleContainers.forEach((container) => {
            const promotionCreative = container.getAttribute('data-promotion-id');
            const firstChild = container.firstElementChild;
            const hasGridCellInnerClass = Array.from(firstChild.classList).some(className => 
                className.startsWith('xy-grid-container')
            );
            
            if (hasGridCellInnerClass) {
                // Handle grid containers - treat each cell as its own banner
                const gridCells = firstChild.querySelectorAll('.xy-grid-cell');
                gridCells.forEach((cell, cellIndex) => {
                    if (!hasClickableContent(cell)) return;

                    promoIndex++;
                    const cellImgSrc = getPromotionImage(cell);
                    const cellLinkText = cell?.dataset?.promotionId || null;
                    const resolvedCreative = cellLinkText || promotionCreative || `${promotionName} ${getOrdinal(promoIndex)} Banner`;

                    const promo = {
                        'promotionName': `${promotionName} ${getOrdinal(promoIndex)} Banner`,
                        'promotionCreativeName': resolvedCreative,
                        'promotionId': cellImgSrc,
                        'promotionIndex': promoIndex,
                        'promotionPosition': promotionName,
                        'promotionType': 'gtm_banner',
                    };

                    promotions.push(promo);
                    promotionByGridCell.set(cell, promo);
                });
            } else {
                // Handle regular containers
                promoIndex++;
                const imgSrc = getPromotionImage(container);
                const position = promoIndex;
                const resolvedCreative = promotionCreative || `${promotionName} ${getOrdinal(position)} Banner`;
                if (container.querySelector('slideshow-component-v2')) {
                let slideshow = container.querySelector('slideshow-component-v2');
                    slideshow.DlInfo = {
                        'promotionName': `${promotionName} ${getOrdinal(position)} Banner`,
                        'promotionId': imgSrc,
                        'promotionCreativeName': resolvedCreative,
                        'promotionIndex': position,
                        'promotionPosition': promotionName,
                        'promotionType': 'gtm_banner'
                    };
                }
                const promo = {
                    'promotionName': `${promotionName} ${getOrdinal(position)} Banner`,
                    'promotionCreativeName': resolvedCreative,
                    'promotionId': imgSrc,
                    'promotionIndex': position,
                    'promotionPosition': promotionName,
                    'promotionType': 'gtm_banner'
                };

                promotions.push(promo);
                promotionByContainer.set(container, promo);
            }
        });

        if (promotions.length > 0) {
            window.dataLayer.push({
                'event': 'view_promotion',
                'promotions': promotions,
                '_clear': true
            });
            allPromotions = promotions;
        }
    })();

    // Listen for clicks on links or buttons inside .dl-container
    document.querySelectorAll('.dl-container').forEach(container => {
        container.addEventListener('click', function(event) {

            const ignoreTags = ['FS-PRODUCT-WIDGET', 'SLIDESHOW-COMPONENT-V2', 'FIT-FINDER-LANDING-PAGE-COMPONENT'];
            const ignoreClasses = ['banner-multi-cta', 'xy-it-list-content-section', 'xy-it-list-content', 'xy-it-list-main-text', 'xy-it-list-block'];
            if (ignoreTags.includes(event.target.tagName) || ignoreClasses.some(className => event.target.classList.contains(className))) {
                return;
            }

            const clickableTarget = event.target.closest('a[href], button, .multi-cta-button, .banner-button, .xy-button');

            const isCustomBannerV2 = container.querySelector('.dnd-root') !== null;
            const isWholeBannerClick = isCustomBannerV2 && !clickableTarget;

            if (!clickableTarget && !isWholeBannerClick) {
            return;
            }

            let buttonText = '';
            let parentContainer = clickableTarget?.closest('[data-promotion-id]') || container;
            let parentA = clickableTarget?.closest('a');

            //filter out false positives where container is non-linking and items contain links
            if (event.target.classList.contains('custom-banner-background') && !parentA) {return;}

            if (!parentContainer) {
            return;
            }

            if (isWholeBannerClick) {
            buttonText = 'Whole Banner';
            }
            else if (
                clickableTarget.classList.contains('multi-cta-button') ||
                clickableTarget.classList.contains('banner-button') ||
                clickableTarget.classList.contains('xy-button') ||
                clickableTarget?.classList.contains('dnd-link') ||
                clickableTarget?.classList.contains('dnd-item')
            ) {
                buttonText =
                    clickableTarget.dataset.linkTitle ||
                    clickableTarget.dataset.promotionId ||
                    clickableTarget.textContent.trim();
            } else if (
                parentA &&
                (parentA.classList.contains('multi-cta-button') || parentA.classList.contains('xy-button'))
            ) {
                buttonText =
                    parentA.dataset.linkTitle ||
                    parentA.dataset.promotionId ||
                    parentA.textContent.trim();
            } else if (
                clickableTarget.classList.contains('xy-section-container-link') ||
                parentContainer.querySelectorAll('.multi-fallback-link').length > 0 ||
                parentContainer.querySelectorAll('.custom-banner-link').length > 0
            ) {
                buttonText = 'Whole Banner';
            }

            const gridCell = event.target.closest('.xy-grid-cell');
            let selectedPromotion = gridCell ? promotionByGridCell.get(gridCell) : null;

            if (!selectedPromotion) {
                selectedPromotion = promotionByContainer.get(container) || null;
            }

            if (selectedPromotion) {
                const promotionPayload = buttonText !== ''
                    ? { ...selectedPromotion, promotionButton: buttonText }
                    : selectedPromotion;

                window.dataLayer.push({
                    'event': 'select_promotion',
                    'promotions': promotionPayload,
                    '_clear': true
                });
                event.__promotionTracked = true;
            }

        });
    });

    // Fallback for wrapper-anchor banners where the click target can be the <a> itself
    // (for example first HP hero), which bypasses .dl-container delegated handlers.
    document.addEventListener('click', function(event) {
        if (event.__promotionTracked) return;

        const wrapperLink = event.target.closest('a.xy-section-container-link[href]');
        if (!wrapperLink) return;

        const nestedContainer = wrapperLink.querySelector('.dl-container');
        if (!nestedContainer) return;

        const selectedPromotion = promotionByContainer.get(nestedContainer);
        if (!selectedPromotion) return;

        window.dataLayer.push({
            'event': 'select_promotion',
            'promotions': {
                ...selectedPromotion,
                promotionButton: 'Whole Banner'
            },
            '_clear': true
        });
        event.__promotionTracked = true;
    });
});

const PLACEHOLDER_IMAGE =
    "https://cdn.shopify.com/s/files/1/2170/8465/files/placeholder.jpg?v=1759779720";

function getPromotionImage(container) {
    const img = container.querySelector('img');

    if (img) {
        return img.src;
    }

    const dndRoot = container.querySelector('.dnd-root');

    if (dndRoot) {
        const style = dndRoot.querySelector('style');

        if (style) {
            const match = style.textContent.match(
                /\.dnd-canvas\s*\{[^}]*background-image\s*:\s*url\(["']?(.*?)["']?\)/i
            );

            if (match?.[1]) {
                return match[1];
            }
        }
    }

    const canvas = container.querySelector('.dnd-canvas');

    if (canvas) {
        const backgroundImage = window.getComputedStyle(canvas).backgroundImage;
        const match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);

        if (match?.[1]) {
            return match[1];
        }
    }

    return PLACEHOLDER_IMAGE;
}